// extracted by mini-css-extract-plugin
module.exports = {"gitea":"SignInWithGitea_gitea__9nwUZ","icon":"SignInWithGitea_icon__2QL4Y"};